import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import theme from 'styled-theming';
import {
  Flex, Box, Image,
} from 'rebass/styled-components';
import { FeatureAnnouncementModal } from '../modal';
import ImagePolicyLogs from '../../assets/banner/policy-logs.png';
import ImageSearch from '../../assets/banner/search.png';
import { useAppState } from '../../hooks';
import { Loading } from '..';

export interface CcsV2FeatureAnnouncementProps {
  closeBanner?: () => void;
}

const LINK_TO_DOCUMENTATION = 'https://developers.liveperson.com/conversation-orchestrator-conversation-context-service-getting-started.html';

const featureOneTitle = 'Understand why routing was a success or failure with our new Policy Logs';
const featureOneImage = ImagePolicyLogs;
const featureTwoTitle = 'Now it is even easire to manage policies through search and pagination';
const featureTwoImage = ImageSearch;

const imageOverlayBackground = theme('mode', {
  light: (props: any) => props.theme.colors.glitter,
  dark: (props: any) => props.theme.colors.modalDarkBackground,
});

const Article = styled(Flex)`
  padding: 44px 36px 0px 36px;
  &:not(:last-child) {
    padding-right: 0;
  }
`;

const FeatureTitle = styled(Flex)`
  font-size: 16px;
  opacity: 0.7;
  text-align: center;
  line-height: 24px;
  margin-bottom: 35px;
  padding: 0px 18px;
`;

const BlockImage = styled(Image)`
  display: block;
  position: absolute;
`;

const ImageOverlay = styled.div`
  position: relative;
  left: 0px;
  top: 190px;
  height: 62px;
  z-index: 1;
  background: linear-gradient(180deg, rgba(29, 29, 71, 0.0001) 0.45%, ${imageOverlayBackground} 56.7%);
`;

const CcsV2FeatureAnnouncement: FunctionComponent<CcsV2FeatureAnnouncementProps> = ({
  closeBanner,
}: CcsV2FeatureAnnouncementProps) => {
  const { isLoading, isCcsV2 } = useAppState();

  if (isLoading) {
    return <Loading size={4} />;
  }

  if (!isCcsV2) {
    return null;
  }

  return (
    <FeatureAnnouncementModal
      feature="maven.feature.new.ccsV2"
      header="We have 2 great new features for you!"
      subheader="Dynamic Routing improvements"
      body={(
        <>
          <Article>
            <Box>
              <FeatureTitle>{featureOneTitle}</FeatureTitle>
              <BlockImage src={featureOneImage} />
              <ImageOverlay />
            </Box>
          </Article>
          <Article>
            <Box>
              <FeatureTitle>{featureTwoTitle}</FeatureTitle>
              <BlockImage src={featureTwoImage} />
              <ImageOverlay />
            </Box>
          </Article>
        </>
      )}
      documentationLink={LINK_TO_DOCUMENTATION}
      closeBanner={closeBanner}
    />
  );
};

export default CcsV2FeatureAnnouncement;
